import { Component, OnInit, AfterViewInit } from '@angular/core';
import { GlobalConstants } from './global-constants';
import { SplashScreenStateService } from './services/splash-screen-state-service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
 public title = 'mnbApp';

 constructor(private splashScreenStateService: SplashScreenStateService) { 
  console.log(GlobalConstants.photosServerPath);
}
  ngAfterViewInit(): void {
  //  throw new Error('Method not implemented.');
 // alert('done');

  var load = document.getElementById("loadText");
  load.style.display = "none";
  setTimeout(() => {
     this.splashScreenStateService.stop();
     
  }, 5000);

  }

ngOnInit(): void {
//  alert('now');
  // var load = document.getElementById("loadText");
  // load.style.display = "none";
  // setTimeout(() => {
  //    this.splashScreenStateService.stop();
     
  // }, 5000);

}



}
